



























































import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {ArrivalSubjectCRMTableRow} from "@/models/ArrivalSubjectCRMTableRowDetails";
import {GridColumn} from "@payroll/grid-widget/src/models/GridColumn";
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'
import {Action} from "vuex-class";


@Component({})
export default class CRMArrivalSubjectTable extends FeedbackComponent {

  @Prop() departmentId: string = ""
  @Prop(Array) rows: any = []


  @Action('getAllSubjectsByDepartment', StoreNamespace.CUSTOMER_SERVICE) getAllSubjectsByDepartment: any;
  @Action('createOrUpdateArrivalSubject', StoreNamespace.CUSTOMER_SERVICE) createOrUpdateArrivalSubject: any;


  private subjectsList: any[] = []
  private columns: GridColumn[] = [];
  private showEditSubjectModal: boolean = false

  private currentArrivalSubjectRow: ArrivalSubjectCRMTableRow = {
    id: -1,
    sla: 1,
    description: "",
    emails: [],
    activeSubject: true
  }


  mounted() {
    this.initColumns()

  }

  @Watch('rows')
  onDepartmentDataChanged() {
    if (this.rows) {
      this.getAllSubjectsByDepartment({
        pathVariable: this.departmentId,
        requestorCallback: this
      });
    }
  }

  @Watch('departmentId')
  onDepartmentIdChanged() {
    this.getAllSubjectsByDepartment({
      pathVariable: this.departmentId,
      requestorCallback: this
    })
  }


  private initColumns(): void {
    this.columns.push({property: 'description', header: 'subject'})
    this.columns.push({property: 'sla', header: 'customerService.popup.slaTitle'})
    this.columns.push({property: 'activeSubjectDescription', header: 'customerService.popup.activeSubjectStatus'})
  }

  onSuccess(data?: any, requestName?: string, message?: string) {

    switch (requestName) {
      case 'crmConfigurationManagement/getAllSubjectsByDepartment':
        this.$emit('successResults', data)
        break;
      case 'crmConfigurationManagement/createOrUpdateArrivalSubject':
        this.$emit('successResults', data)
        this.showSuccessAction(`עריכת הנושא ${this.currentArrivalSubjectRow.description} בוצע בהצלחה`)
        this.onHideEditSubjectModal()
        break;
    }
  }


  onEditClick(data: any): void {
    this.currentArrivalSubjectRow = {...data}
    this.showEditSubjectModal = true
  }

  onHideEditSubjectModal() {
    this.currentArrivalSubjectRow = {
      id: -1,
      sla: 1,
      description: "",
      emails: [],
      activeSubject: true
    }
    this.showEditSubjectModal = false
  }

  onSaveSubject() {

    const request = {
      ...this.currentArrivalSubjectRow,
      departmentId: this.departmentId
    }

    this.createOrUpdateArrivalSubject({
      requestorCallback: this,
      requestBody: request
    })
  }

  private showSuccessAction(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

};


